import { initializeApp } from 'firebase/app';
import { 
    getAuth, 
    onAuthStateChanged,
    signInWithEmailAndPassword,
    signOut,
    setPersistence,
    browserLocalPersistence,
    browserSessionPersistence,
    signInWithCustomToken,
    signInWithPhoneNumber,
    RecaptchaVerifier
} from 'firebase/auth';
import { 
    getFirestore, 
    doc, 
    getDoc, 
    setDoc, 
    updateDoc, 
    serverTimestamp,
    collection,
    query,
    where,
    getDocs,
    addDoc,
    limit,
    deleteDoc
} from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseEnv = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const requiredFirebaseKeys = ['apiKey', 'authDomain', 'projectId', 'storageBucket', 'messagingSenderId', 'appId'];
const missingFirebaseKeys = requiredFirebaseKeys.filter((key) => !String(firebaseEnv[key] || '').trim());
if (process.env.NODE_ENV === 'production' && missingFirebaseKeys.length) {
    throw new Error(`Missing Firebase production configuration: ${missingFirebaseKeys.join(', ')}`);
}
if (process.env.NODE_ENV !== 'production' && missingFirebaseKeys.length) {
    console.warn(`[Firebase] Missing development configuration: ${missingFirebaseKeys.join(', ')}`);
}

// Development fallbacks preserve the existing local project behaviour only.
// Production builds are forced to provide explicit environment configuration.
const firebaseConfig = {
    apiKey: firebaseEnv.apiKey || 'AIzaSyAIZlXy2LKJwwZRXxQ_5hvqVHZ3N8ZOE3g',
    authDomain: firebaseEnv.authDomain || 'telcofair-eb4f1.firebaseapp.com',
    projectId: firebaseEnv.projectId || 'telcofair-eb4f1',
    storageBucket: firebaseEnv.storageBucket || 'telcofair-eb4f1.appspot.com',
    messagingSenderId: firebaseEnv.messagingSenderId || '123456789012',
    appId: firebaseEnv.appId || '1:123456789012:web:abcdef1234567890',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Auth
const auth = getAuth(app);

// Firestore
const db = getFirestore(app);

// Storage
const storage = getStorage(app);

// Functions
const functions = getFunctions(app, process.env.REACT_APP_FIREBASE_FUNCTIONS_REGION || process.env.REACT_APP_FUNCTIONS_REGION || 'us-central1');

export {
    app,
    auth,
    db,
    storage,
    functions,
    // Auth
    onAuthStateChanged,
    signInWithEmailAndPassword,
    signOut,
    setPersistence,
    browserLocalPersistence,
    browserSessionPersistence,
    signInWithCustomToken,
    signInWithPhoneNumber,
    RecaptchaVerifier,
    // Firestore
    doc,
    getDoc,
    setDoc,
    updateDoc,
    serverTimestamp,
    collection,
    query,
    where,
    getDocs,
    addDoc,
    limit,
    deleteDoc
};